import React from 'react'
import {
	Chart,
	ChartData,
	ChartOptions,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'
import { IMountainPlayerData } from '../../../helpers/data/mountainPlayer'
import { IGameActivity } from '../../../helpers/data/question'
import { useBuildClassPerformanceData } from '../../../helpers/hooks'

import { ResizeObserver as Polyfill } from '@juggle/resize-observer';

window.ResizeObserver = window.ResizeObserver || Polyfill;

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels)

interface IClassPerformanceProps {
	players: IMountainPlayerData[]
	activity: IGameActivity
	areAnswersHidden: boolean
}

const verticalBarChartOptions: ChartOptions<'bar'> = {
	responsive: true,
	layout: {
		padding: {
			top: 24,
			left: 24,
			right: 24,
			bottom: 32,
		},
	},
	animation: {
		duration: 300,
	},
	elements: {
		bar: {
			borderSkipped: false,
			borderRadius: 4,
			borderWidth: 2,
		},
	},
	plugins: {
		tooltip: {
			enabled: false,
		},
		legend: {
			display: false,
		},
		datalabels: {
			font: {
				family: 'sans-serif',
				size: 12,
				weight: 500,
				lineHeight: 1.5,
			},
			color: '#8B9195',
			align: 'center',
			anchor: 'end',
			formatter: (l) => `${l}\n`,
		},
	},
	scales: {
		x: {
			grid: {
				// hide chart lines
				display: false,
				drawOnChartArea: false,
			},
			border: {
				display: false,
			},
			ticks: {
				//handle render dataset labels
				padding: 0,
				font: {
					size: 14,
					lineHeight: '16px',
					weight: 'normal',
				},
				color: '#3F535D',
			},
		},
		y: {
			display: false,
		},
	},
}

const ClassPerformance: React.FC<IClassPerformanceProps> = ({ players, activity, areAnswersHidden }) => {
	const chartData: ChartData<'bar'> = useBuildClassPerformanceData(players, activity, areAnswersHidden)

	return chartData && <Bar data={chartData} options={verticalBarChartOptions} />
}

export default ClassPerformance
